module.exports = __webpack_public_path__ + "static/media/fb_logo.b0c619f0.svg";